module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Draycott Everlasting")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("CHAPTER ONE")])])])])]), _c('p', {
    staticClass: "chapterDateline"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Glenbrae House"), _c('br'), _vm._v("\nLate November, seven months later")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_vm._v("H"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("OPE LISTENED TO A")])]), _vm._v(" thrush trill. Outside her window the last hardy roses burned in glorious color, their sinuous vines coiling up Glenbrae House’s stone walls.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Blue and white porcelain gleamed on the mantel above the fireplace, and bright chintz chairs warmed the corners beside the window. Sunlight glinted off the polished floor, just as she had pictured it on her first visit.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The inn she had dreamed of that sunny afternoon was finally nearing completion. Unfortunately, luring paying guests to the quiet valley had not turned out to be so easy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hope frowned at her easel. Her latest attempt to reproduce the figure painted on the stairwell was faring no better than her other efforts. The man’s face was too flat. Too cold. With no hint of life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Even now, months after moving into Glenbrae House, the brooding image on the stairwell continued to fascinate her. Hope decided he was a medieval warrior sent on the king’s service. Something covert, no doubt, involving jewels or secret documents to be transferred to a safe hiding place out of reach of the king’s enemies.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("With eyes like that, the man knew the weight of dangerous secrets. He bore the hard responsibility of human life ")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("and death. Each hard choice was marked on the canvas of his proud face, hidden in the depths of his shadowed eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Hope sighed and put away her brushes. For the past weeks, every picture she painted seemed to incorporate the medieval figure above the staircase. Even her dreams were touched by images of a broad-shouldered figure with keen silver eyes. Sleeping hadn’t been easy, to say the least.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Considering the sad state of her finances, sleeping wasn’t likely to get any easier. Not without a genuine, honest-to-goodness miracle.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("But Scotland seemed to be a place for miracles.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("A door slammed downstairs. Footsteps tapped over the polished floor from the kitchen, and a voice called up, “I have the chocolate tea cakes. And the Wishwells have sent over more homemade wine.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("A delicious aroma of chocolate and roasting almonds drifted up the stairs. Hope remembered that she hadn’t eaten since breakfast.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("She stretched, then slid her brushes into a glass of clean water, studying her mysterious subject. “Gotta go, MacLeod.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("For a moment she could have sworn a gust of wind swept over her neck. Impossible, of course. The windows were sealed and the room was comfortably warm.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Too much imagination, she thought wryly. That was another thing that Scotland’s brooding landscape seemed to foster.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Coming right down, Gabrielle,” she called.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Her bank account might be at rock bottom, but thanks to the generosity of her neighbors and the skill of her young Parisian chef, they would always eat well. Baskets of tomatoes fresh from the vine had appeared at the front door all summer, followed by armloads of cheese and homemade delicacies. None of her neighbors would accept a pence in payment; by same baffling, unspoken knowledge, all of them knew of Hope’s financial predicament.")])])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("At first she had tried to refuse, only to discover that the “extra” produce was left anyway. The more she refused, the more was given. Even now the quiet generosity of the Highlanders left her in awe.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If only she had as many paying guests as she did vegetables from her neighbors’ fields…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She sighed, walking to the window. The last of the hollyhocks peeked among the hedges. The magical scene almost helped Hope ignore the way the thatched roof tilted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The expert she had called in several months ago had told her that even the best thatch had to be replaced every twenty years, and Glenbrae House’s roof had not seen replacement for half a century. Unfortunately, bills for a dozen other repairs already awaited payment, from hinges for the leaded windows in the study to new plumbing in the guest rooms and carpeting for the front salon. All bad enough.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Now a new roof. Where would it end?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hope shoved a strand of chestnut hair off her forehead and followed the scent of tea cakes to the kitchen. Today her French chef sported computer-chip earrings and a huge necklace made of silicon wire.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Nice earrings,” Hope said, settling at the broad table and gratefully accepting a steaming cup of Earl Grey tea from her young chef. Although barely twenty-one, Gabrielle was an extrovert with a world-class network of contacts stretching from the Arctic to the Amazon.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“In "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("honneur")])]), _vm._v(" of the Glenbrae Investment Club, I try out some new recipes for their favorite food.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Zucchini again, I take it?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her chef nodded happily. “Curried zucchini soup. And the corn bread with the so very hot chilies, from my friend in New Mexico.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("It was a lucky thing that their spry septuagenarian neighbors had stomachs of iron and opinions to match. They liked their food hot and their arguments noisy. Most nights ")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("their investment meetings turned into loud and personal shouting matches, though somehow no feelings seemed to be hurt. Hope seemed to know exactly when to interrupt with pitchers of fresh lemonade and Gabrielle’s steaming soup, flanked by wedges of hot corn bread.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“They make much money, these investors of Glenbrae?” the Frenchwoman asked, setting down her cup of tea.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“Rich as Croesus, I believe. Last month they received dividend checks that made me drool. They keep insisting that I should let them establish an account for me.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“And why do you not?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“You know very well why, Gabrielle.” Hope studied the cozy kitchen, where sunlight glinted off hanging copper pots and herbs strung from beams in the ceiling. “I have no money for anything extra. This beautiful old house is all the gamble I can afford. And if I don’t have paying guests soon, even this gamble will be lost.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("The young Parisian slid off her white toque and tapped her jaw. “I have been thinking about this and then the perfect idea comes to me. It is a thing that will make Glenbrae House as popular as the beautiful Draycott Abbey. I visited only last year, you know. Marston, my butler friend there, tells me the tourists come every week by busloads.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“Draycott Abbey. That’s in England, isn’t it?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("The silicon chips danced madly as Gabrielle nodded. “All granite and glass, a most beautiful place. Marston says it draws visitors like a magnet, mainly because of its ghost.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“Ghost?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“A very eccentric and dashing figure with a reputation most evil. The tourists love it because he walks the battlements.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Hope hid a smile. “Did you actually see him?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“No, but some have,” Gabrielle said defensively. “Very many of them.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“That’s all very well for Draycott Abbey, but we don’t ")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("have any historic treasures here. Even the history of Glenbrae is sketchy.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Gabrielle smiled shrewdly. “But you have other things just as good as history. Soon you will have the tourists in busloads, too. Just like Draycott Abbey.” Gabrielle slid another slice of cake onto Hope’s plate. “And it is only one little lie.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Giving me more cake isn’t going to change my mind.” Hope sighed. “I should at least be starving by now, considering that we’re perched on the brink of complete ruin.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Good day or bad, one must eat,” Gabrielle announced with Gallic pragmatism. “Hours pass and you eat not one scrap. Always you work, you pace, you paint.” Gabrielle toyed with the chunky silicon earrings at her cheeks. “But now I see the answer most perfect.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("All Hope could see was an endless future of rising debt and leaking thatch. She moved her spoon, drawing crosses in a butter-light ridge of icing. “I’m afraid to ask.” As a cook, Gabrielle was a genius, but her common sense was noticeably weak.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("So Hope refrained from reminding her friend that her prior efforts to forcibly detour tour buses past the inn had resulted in a massive traffic jam and a threatened civil action by the county constable.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“No more problems with the police, I assure you.” The chef’s dark eyes gleamed. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Pigs,")])]), _vm._v(" that’s what they are. But now from miles around people will fight to spend the night beneath our roof. All it takes is one small addition, one thing every tourist wants.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Free breakfast?” Hope added a row of dollar signs to the buttercream crosses.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“You are too practical. What people want is excitement, passion. Danger mixed with romance.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Don’t tell me you’re hiring Tom Cruise to work in the kitchen. Or maybe Mel Gibson. I doubt that I could afford either one for a sous-chef.”")])])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It is a joke, no? I do not hire these men. Me, I find something much better for you than any man. I find you—a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("ghost.”")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ve sensed magic and stirring history in Glenbrae, but never any ghosts.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It is the perfect thing to make the tourist’s heart drum like thunder, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("non?")])]), _vm._v(" First, they hear the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("bang-bang")])]), _vm._v(" in the night.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That would be the water pipes going,” Hope muttered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then they see a shape, all cobwebs and mist, gliding up the stairway.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That would probably be our dust motes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The chef ignored her. “Now they are frightened, trembling. They clutch their hearts and race forward, desperate to see more. Then they hear the throb of laughter, low and terrifying. Closer it comes, rippling down the stairs.” Gabrielle’s voice rose. “Now they shiver with fright, eager to tell all their friends about the haunted-house tour in Glenbrae. Soon you will be very rich.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t know about that….”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You Americans love the thought of a ghost in the bedroom, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("non? Voilà,")])]), _vm._v(" in a week you have more visitors than beds to hold them and no more problems of money for you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hope sat back slowly. “You’re saying that Glenbrae House needs a ghost in the bedrooms?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Of course not.” Gabrielle smiled sagely. “What we need is the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("idea")])]), _vm._v(" of a ghost, one to summon only while the guests are here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Out of thin air, I suppose.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But no. Out of the old curtains, of course.” Gabrielle sat forward eagerly. “And just today in the village I meet a friend whose specialty is "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Macbeth.")])]), _vm._v(" I am certain he can help us.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Really, Gabrielle, I don’t think you understand—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The Frenchwoman strode to the side door leading out to Hope’s herb garden. “You will please to come in now, Mr. Jeffrey.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("A gangling youth in a rumpled white shirt and threadbare ")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("flannels rose from behind the ragged hollyhocks and rocked anxiously from foot to foot. “Don’t blame Gabrielle,” he said, picking up the conversation as if he’d been part of it all along. “This was all my idea. I’ve been doing some amazing lighting effects for the drama project I just completed. ‘New Concepts in "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Hamlet")])]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Macbeth.’")])]), _vm._v(" Might even be put down for an honors when I’m done.” He frowned, as if thinking of something unpleasant, then shrugged. “Not that any of that matters. The thing is, with backlighting and a double-colored floodlight, angles can be made to recede and corners can be blurred.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("Hope didn’t see the connection. “They can?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“Of course.” His cultured voice burst with enthusiasm as he ambled into the kitchen. “Special effects are everything today. You take a pinch of dry ice here and some chemical smoke there.” He waved one hand. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Voilà.”")])])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“Then you have a fire hazard on your hands?” Hope said dryly.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("Jeffrey slid into the seat opposite, eyeing Gabrielle’s last wedge of almond cake. Hope was fairly certain she heard his stomach rumble. She decided that he could use a good meal, since he looked dangerously thin. “Be my guest,” she said, sliding the plate closer.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("She had to appreciate his bitter effort to resist. “Oh, I couldn’t. We barely know each other, and Gabrielle made it for you, after all.” He looked at Hope’s chef with doglike devotion.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("Hope filed that look away for future reference. “But I insist. I couldn’t eat another bite.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("Hunger finally won out over good form. Half of the slice was gone within seconds, the other half consumed more slowly, while the young drama student’s pale blue eyes closed in silent rapture. He scraped the last piece of icing off with his thumb, then linked his fingers eagerly. “It will work. Trust me, I’m an expert at ghosts.”")])])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re a parapsychologist?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, a lighting specialist. Our test performance of "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Macbeth")])]), _vm._v(" went off without the slightest hitch. Mr. Willett-Jones said I was the best thing since dry ice.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Mr. Willett-Jones is your professor, I take it?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hardly. He’s the drama critic for the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Observer.")])]), _vm._v(" It’s a small paper, but it has a good deal of clout in dramatic circles.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hope wondered if Jeffrey’s parents knew about those “dramatic circles.” Or if they cared. The boy looked as if he was wearing his last shirt, and he clearly hadn’t eaten properly for quite some time.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Jeffrey is good, I swear it,” Gabrielle said firmly. “When he makes the lights follow his ghost onstage, my skin creeps most terribly. Even I believe it is real.” From the sternly pragmatic Gabrielle, this was praise indeed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As the two stared at her, Hope had the perilous feeling she had lost the argument before it had even begun. “I’m afraid it’s out of the question. I won’t lure visitors to Glenbrae under false pretenses.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You don’t understand.” Jeffrey rocked forward on bony elbows. Though worn, his shirt was custom-made, with fine hand seaming inside. “"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("All")])]), _vm._v(" these old wrecks have ghosts. Glamis has dozens of them, and Windsor is chock-full of odd knocks and bangs.” Jeffrey looked very pleased with himself. “I remember my mum always used to say—” His smile abruptly faded.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Even if I wanted to try it—which I don’t—there’s no way your scheme could work,” Hope said quickly. “It wouldn’t be convincing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jeffrey roused himself from his reverie and jammed long fingers into his hair, frowning. “Wrong again. Gabrielle showed me around this morning while you were working, and I’ve got the whole place mapped out. I already have a list of the materials I’ll need.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hope swallowed. “Materials?”")])])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gabrielle beamed. “He is very organized, you see.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jeffrey tried to hide a flush at her praise. “All your visitors will see is a lovely hint of ghostly garments drifting down the stairs. Add some wonderfully maniacal laughter and it’s guaranteed to bring down the house.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He moved closer to Gabrielle. Together the two stared at Hope.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Now, just wait a minute. Even if this apparition "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("did")])]), _vm._v(" work, how would you get the word out? You can’t post a sign in the village announcing that Glenbrae House now has a resident ghost.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gabrielle cracked eggs, then added vanilla and cream for a rich chocolate sauce. “Just today Jeffrey and I pass a group of tourists on the way to hike in the hills. I hear them complain there is nothing to see in Glenbrae. But I explain very carefully about the secret of our little village.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And just what is that?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The secret ghost of Glenbrae House, of course.”")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("WENTY MINUTES LATER,")])]), _vm._v(" shadows filled the great hall.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Plumes of smoke drifted along the oak banister. Only the wood paneling and stairway were visible in the semidarkness.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Not like that. Slower. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Glide.”")])]), _vm._v(" Jeffrey’s voice was muffled as he crouched behind a velvet sofa, toying with a complicated electrical panel. “You’re supposed to be terrifying, remember? A bloody apparition from beyond the grave.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hope tugged at the microfiber shrouding her head and did her best to glide. “There’s no way that this can work, you two. I wouldn’t fool a blind man.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But you are wrong,” Gabrielle said. “In the darkness your sleeves glow like fire itself, and you are the picture of a ghost. Just keep coming. Jeffrey has run the wires under the carpet so you will not trip.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("“There’s another problem.” Hope paused on the stairs. ")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("“All this electrical equipment and wiring you mentioned is going to cost a lot of money—money that I just don’t have. I can’t afford to pay you, either. Maybe it would be better if we forgot the whole idea right now and—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“No problem,” Jeffrey said eagerly. “I have a van full of equipment on loan from the university until the end of term, free and clear. It’s almost as if fate has stepped in. Actually, I think Glenbrae House was "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("meant")])]), _vm._v(" to have a ghost.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("Hope closed her eyes and prayed that Glenbrae House was not "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("meant")])]), _vm._v(" to have a lawsuit filed by an irate tourist.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("As Jeffrey worked over a different row of buttons, the light intensified. Hope’s diaphanous gown rippled.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Now start the tape recording, Gabrielle.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("A bloodcurdling howl erupted from the floorboards outside the kitchen. The effect of the shriek, combined with the ghostly illusion, was quite remarkable.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“I’m going to hit the lights. Hope, you can start moving along the landing.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("Dutifully Hope stepped forward, awaiting her cue. In the sudden darkness she could almost imagine the hushed silence of the house as it had been centuries before, lit only by candles and overseen by its stern-eyed master, the MacLeod.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("An odd prickling sensation ran down her neck.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Go,”")])]), _vm._v(" Jeffrey ordered in his best stage director’s voice.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("Hope glided down the stairs as Jeffrey had instructed, her hands floating out beside her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Perfect. Gabrielle, hit the third button.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("A pale gleam emanated from the ceiling, taking shape at the curve of the stairway, where two long sleeves, a ghastly fluorescent head and a trailing gown drifted over the steps.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("No wind touched the room.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("No noise marked the apparition’s descent.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("Hope finally reached the turn of the stairs, feeling her way with her fingers in the darkness. She could barely breathe beneath the cowl Jeffrey had draped over her head, and she ")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("could see almost nothing. At the third step, something caught the hem of Hope’s ghostly gown, and when she grappled for the wall, something pricked her finger hard.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("She bit back a hiss of pain. “Jeffrey, I don’t think—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("“Great. Just fabulous. Now do the rest, the way we rehearsed.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("“But I still don’t think—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Go on.”")])])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("Sighing, Hope raised her arm. As the lights changed, her ghostly shape took full form in the darkness. Then the silence was split by a shattering scream, and the ghostly head separated from its body and flew toward the ceiling, accompanied by ghoulish laughter.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("Outside, the front steps creaked. “Miss Hope?” The oak door opened slowly. “Is anyone here?” A white-haired head appeared in the gloom of the front hall.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("Wildly Hope clutched at the yards of fabric trapping her face. She tried to answer, but every sound was muffled by her costume. After a moment she recognized the voice.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("Morwenna Wishwell. An inveterate meddler, but a wonderful neighbor.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("With sickening clarity Hope envisioned her first lawsuit: a spry old lady shocked into an early grave by the sight of a headless apparition flittering over Glenbrae’s oak banister.")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page28"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ecb71a1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/draycotteverlasting_ch02.vue
// module id = 78
// module chunks = 0